import { GitFork, Loader2 } from "lucide-react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useForkSession } from "../../api/sessions";
import { useChatSession } from "../../context/ChatSessionProvider";
import { ActionButton } from "./ActionButton";

export const ForkSessionButton = () => {
  const { sessionId, routeBase } = useChatSession();
  const navigate = useNavigate();
  const forkMutation = useForkSession();

  const handleFork = useCallback(async () => {
    if (!sessionId) return;
    try {
      const newSessionId = await forkMutation.mutateAsync(sessionId);
      navigate(`${routeBase}/${newSessionId}`);
      toast.success("Session forked — you're now in the new copy");
    } catch {
      toast.error("Failed to fork session");
    }
  }, [sessionId, forkMutation, navigate, routeBase]);

  if (!sessionId) return null;

  return (
    <ActionButton
      label={forkMutation.isPending ? "Forking..." : "Fork session"}
      onClick={handleFork}
      disabled={forkMutation.isPending}
    >
      {forkMutation.isPending ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <GitFork className="h-3.5 w-3.5" />
      )}
    </ActionButton>
  );
};
